const config = {
    // localhost_url:'http://localhost:8089', 
    // localhost_url: 'http://192.168.0.113:8089', // local dev test
    // localhost_url:'http://18.61.135.100:8089',//new test link hyd
    localhost_url: "https://load.goslash.com", // prod
}
export let apiKeys = {}
if (config.localhost_url === 'https://load.goslash.com') {
    apiKeys = {
        environment: "production",
        googleApiKey: 'AIzaSyCHvGHPNkUvWRF_5mitUotvx1T4M6lvE-s',
        ipApiKey: 'fd1b56f1a7e14bc7aa238e2d7e3b15d7166ea28c',
        // fireBaseConfigKey:"AIzaSyAEnxiyIE_NjRq0S2GLCmJ2oJil_5-W6-0", ////// using in app.js file for firebase initialization so commented here becuase of total config file using there
        firebaseConfig:{
            apiKey: "AIzaSyAEnxiyIE_NjRq0S2GLCmJ2oJil_5-W6-0",
            databaseURL: "https://slash-merchant-prod.firebaseio.com",
            projectId: "slash-merchant-prod",
            storageBucket: "slash-merchant-prod.appspot.com",
            messagingSenderId: "952500173858",
            appId: "1:504617127469:ios:18b05206ab9c5d7778f2a4",
        },
        moengageKey:"2H4XUG1P0A8X8IS8B1FEMUHX"
    }
    
          
}
else {
    apiKeys = {
        environment: "local_dev_test",
        googleApiKey: 'AIzaSyC-RUN07RWQ0ZiaQBBA4-TAyybthyFfi1Y',
        ipApiKey: 'fd1b56f1a7e14bc7aa238e2d7e3b15d7166ea28c',
        // fireBaseConfigKey: 'AIzaSyDsM1SvSNCAzOOKTYoe1xRWcnVfJQzJUW0',
        firebaseConfig:{
            apiKey: 'AIzaSyDsM1SvSNCAzOOKTYoe1xRWcnVfJQzJUW0',
            databaseURL: "https://slash-merchant-test.firebaseio.com",
            projectId: "slash-merchant-test",
            storageBucket: "slash-merchant-test.appspot.com",
            messagingSenderId: "980378996074",
            appId: "1:773003820378:ios:51bba918e498a2d7318763",
        },
        moengageKey:"DOSCI765H72IT7AKCOAZ0DLH"
    }
}
export default config;
